import { actions } from '@atlassian/jira-software-backlog-filters-store/src/controllers/filters/actions/main.tsx';
import type { Actions } from '@atlassian/jira-software-backlog-filters-store/src/controllers/filters/actions/types.tsx';
import { getEpic } from '@atlassian/jira-software-backlog-filters-store/src/controllers/filters/selectors/epic/index.tsx';
import { getFilters } from '@atlassian/jira-software-backlog-filters-store/src/controllers/filters/selectors/filters/index.tsx';
import { getFixVersion } from '@atlassian/jira-software-backlog-filters-store/src/controllers/filters/selectors/version/index.tsx';
import { createStore, createHook } from '@atlassian/react-sweet-state';
import { storeId } from '../../common/constants';
import type { State } from '../../common/types';

const initialState: State = {
	filters: {},
};

export const FiltersStore = createStore<State, Actions>({
	name: storeId,
	initialState,
	actions,
});

export const useFilters = createHook(FiltersStore, {
	selector: getFilters,
});

export const useEpicFilters = createHook(FiltersStore, {
	selector: getEpic,
});

export const useFixVersionFilters = createHook(FiltersStore, {
	selector: getFixVersion,
});
